import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { ActionTriggerService } from '@client/app/shared-modules/tracking/action-trigger/action-trigger.service';

import { GlobalToastMessageService } from '@client/app/shared-modules/global-toast/services/global-toast-message.service';
import { TranslateModule } from '@client/app/modules/translate.module';
import { TooltipModule } from 'primeng/tooltip';
import { SvgIconComponent } from '@client/app/shared-modules/svg-icons/components/svg-icon/svg-icon.component';

@Component({
    selector: 'mon-copy-to-clipboard-button',
    imports: [
        ButtonModule,
        TranslateModule,
        TooltipModule,
        SvgIconComponent,
    ],
    templateUrl: './copy-to-clipboard-button.component.html',
    styleUrl: './copy-to-clipboard-button.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CopyToClipboardButtonComponent {
    @Input() textToCopy: string = '';
    @Input() trackingAction: string = 'copy-to-clipboard-btn';
    @Input() ariaLabel: string = '';
    @Input() tooltipText: string = '';
    @Input() successMessage: string = '';

    constructor (
        private readonly actionTriggerService: ActionTriggerService,
        private readonly globalToastMessageService: GlobalToastMessageService,
    ) {}

    copyToClipboard (): void {
        this.actionTriggerService.track({
            action: this.trackingAction,
        });

        navigator.clipboard.writeText(this.textToCopy).then(() => {
            this.globalToastMessageService.success(this.successMessage);
        });
    }
}
